import { animate, style, transition, trigger } from '@angular/animations';

export const animDropDown = trigger('animDropDown', [
    transition('hide => show', [
        style({ transform: 'scale(0.1)', opacity: '0' }),
        animate('.1s', style({ transform: 'scale(1)', opacity: '*' }))
    ])
]);
